import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';

const UnAuthenticatedRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <div>Loading...</div>;

  console.log('Unauthenticated route:', isAuthenticated);
  return !isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default UnAuthenticatedRoute;
